/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Feature_Background_DescriptionInputs */

const en_marketing_feature_background_description = /** @type {(inputs: Marketing_Feature_Background_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cron triggers, typed queue-backed jobs, and durable multi-step workflows.`)
};

const es_marketing_feature_background_description = /** @type {(inputs: Marketing_Feature_Background_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cron triggers, trabajos tipados sobre colas y flujos de trabajo duraderos de varios pasos.`)
};

const fr_marketing_feature_background_description = /** @type {(inputs: Marketing_Feature_Background_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cron triggers, tâches typées adossées à des files et workflows durables en plusieurs étapes.`)
};

/**
* | output |
* | --- |
* | "Cron triggers, typed queue-backed jobs, and durable multi-step workflows." |
*
* @param {Marketing_Feature_Background_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_feature_background_description = /** @type {((inputs?: Marketing_Feature_Background_DescriptionInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Feature_Background_DescriptionInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_feature_background_description(inputs)
	if (locale === "es") return es_marketing_feature_background_description(inputs)
	return fr_marketing_feature_background_description(inputs)
});